import React from "react";
import ReactDOM from "react-dom/client";
import PortfolioPage from "./pages/PortfolioPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <PortfolioPage />
  </React.StrictMode>,
);
